// import Perssonels from './Perssonels';

export default {
  priority: 10,
  path: 'positionShifts',
  permissions: ['TimeAttendanceMenu/ShiftMenu/UserShiftMenu'],
  // component: Perssonels,
  component: load(() => import(/* webpackChunkName: "Shift-Perssonels" */ './ShiftUserList')),
  name: app.translate('routes.home.attendance.shift.Position shifts'),
  icon: 'account-location',
  drawer: true,
};


